export interface HighlightedTextPart {
  text: string;
  isHighlight: boolean;
}

export function parseHighlightedText(text: string): HighlightedTextPart[] {
  const parts = text.split(/(?<highlight><highlight>.*?<\/highlight>)/g);

  return parts.map(part => {
    const isHighlight = part.startsWith('<highlight>') && part.endsWith('</highlight>');

    return {
      text: part.replace(/<\/?highlight>/g, ''),
      isHighlight,
    };
  });
}
